var path = 'scripts/views/directives/mark-reviewed-button.html';
var html = "<button class=\"mark-as-reviewed btn mls action-button\"\n        ng-click=\"MarkReviewedButtonController.onClick()\"\n        ng-class=\"MarkReviewedButtonController.allTransactionsReviewed() ? 'btn-default' : 'btn-primary'\"\n        ng-disabled=\"MarkReviewedButtonController.isDisabled()\"\n        ng-if=\"MarkReviewedButtonController.showButton()\"\n        tabindex=\"0\">\n        <span class=\"fa fa-eye\"></span>\n  <span>{{ MarkReviewedButtonController.buttonText() | translate }}</span>\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/directives/mark-reviewed-button.html
// module id = 378
// module chunks = 0